import NewFloorplanModal, {
  NewFloorplanModalParams,
} from './new-floorplan-modal';
export type { NewFloorplanModalParams };
export default NewFloorplanModal;
